"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVendorReducer = exports.createVendorReducer = exports.fetchVendorReducer = exports.updateVendorSlice = exports.createVendorSlice = exports.fetchVendorSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const vendorAction_1 = require("./vendorAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.fetchVendorSlice = (0, toolkit_1.createSlice)({
    name: "vendor/fetch",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(vendorAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(vendorAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(vendorAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.createVendorSlice = (0, toolkit_1.createSlice)({
    name: "vendor/create",
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(vendorAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(vendorAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(vendorAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.updateVendorSlice = (0, toolkit_1.createSlice)({
    name: "vendor/update",
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(vendorAction_1.update.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(vendorAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(vendorAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchVendorReducer = exports.fetchVendorSlice.reducer;
exports.createVendorReducer = exports.createVendorSlice.reducer;
exports.updateVendorReducer = exports.updateVendorSlice.reducer;
